export class SoaContractModel {
    userId: string;
    agentUserId: string;
    appointmentDate: string;
    agentSalesId: string;
    methodOfContact: string;
    medicarePlans: string;
    deliveryMethods: any;
}
